import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject } from "@angular/core";
import { ConversationService } from "../../../app/services/conversation.service";

@Component({
  selector: "app-conversation-input",
  templateUrl: "./conversation-input.component.html",
  styleUrls: ["./conversation-input.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConversationInputComponent implements OnInit {
  private conversation = inject(ConversationService);
  private cd = inject(ChangeDetectorRef);

  text: string;

  ngOnInit(): void {}

  send() {
    this.conversation.sendMessage(this.text, "standard");
    this.text = null;
    this.cd.detectChanges();
  }
}
